import React from 'react';

export default function SingleCheckboxHandlar({
  Label = "",
  Value = true, // the value to set when checked
  Name = "checkbox",
  setFormData,
  form_data
}) {
  const isChecked = !!form_data[Name]; // Convert to boolean

  const handleCheckBox = (e) => {
    const { checked } = e.target;

    // If checked, store `Value`; otherwise, store false/null
    setFormData({
      ...form_data,
      [Name]: checked ? Value : false
    });
  };

  return (
    <div className='form-group m-0'>
      <div className='d-flex flex-wrap'>
        <div className="form-check me-1">
          <input
            id={`${Label}`}
            className="form-check-input"
            type="checkbox"
            name={Name}
            checked={isChecked}
            value={Value}
            onChange={handleCheckBox}
          />
          <label className="form-check-label" htmlFor={`${Label}`}>
            {Label}
          </label>
        </div>
      </div>
    </div>
  );
}
